import BaseClass from './BaseClass';
import Util from '../util/Util';

/**
 * スクロール位置を起因とするアニメーション実行の基礎クラス
 * @param {String} _target 対象となるクラス名やid名
 */
export default class SectionBaseClass extends BaseClass {
    constructor(_target) {
        super();
        this.name = "SectionBaseClass";

        this._target = _target;
        this.isStart = false;
        this.isLoad = false;
        this.isActive = false;
        this.target = null;
        this.offset = {top:0,bottom:0};
        this.htmlLast = 0;
        this.scrollTop = 0;
        this.isInsertActive = true;

        this.activePointSp = 0.16;
        this.activePointPc = 0.25;
    }

    onCreate(){
        super.onCreate();
        this.target = (typeof this._target == "string")? $(this._target) : this._target ;
    }

    onLoad(){
        super.onLoad();
        this.isLoad = true;
    }

    onStop(){
        super.onStop();
        this.isLoad = false;
    }

    onRemove(){
        super.onRemove();
        this.isStart = false;
        this.isActive = false;
        this.target = null;
    }

    onResize(_size){
        super.onResize();
        if(!this.target || Util.isSpNavOpen || this.target.is(':hidden')) return;
        let s = (Util.isBreakpoint)? this.activePointSp : this.activePointPc ;
        let wh2 = _size.h - _size.h * s;
        let offset = $.extend({},this.target.offset());
        let top = Math.floor(offset.top);
        let bottom = Math.floor(top + this.target.outerHeight(true) * 0.8);
        this.offset = {top:top - wh2,bottom:bottom};

        this.htmlLast = $("body").outerHeight(true) - _size.h - 10;
    }

    onScroll(_st){
        super.onScroll();
        if(!this.target || !this.isImageLoadEnd || Util.isSpNavOpen || this.target.is(':hidden') || !this.offset) return;
        this.scrollTop = _st;
        if((_st >= this.offset.top && _st <= this.offset.bottom) || (_st >= this.htmlLast && _st < this.offset.top)) {
            if (!this.isStart && this.isLoad) {
                this.isStart = true;
                if(this.isInsertActive) this.onStart();
            }
            if (!this.isActive && this.isLoad) {
                this.isActive = true;
                if(this.isInsertActive) this.onActive();
            }
        } else {
            if(this.isStart && this.isLoad){
                this.isStart = false;
                if(this.isInsertActive) this.onStop();
            }
        }
    }

    onActive(){
        //console.log(this.name,"onActive");
    }

    onStart(){
        //console.log(this.name,"onStart");
    }

    onStop(){
        //console.log(this.name,"onStop");
    }
}